import classNames from 'classnames';
import type { ReactNode } from 'react';

import classes from './Tabs.module.scss';

export interface TabPanelProps {
  children?: React.ReactNode;
  className?: string;
  active: boolean;
  tabId: string;
}

/** Tab panel markup (no client hooks); safe for RSC and client islands. */
export function TabPanel(props: TabPanelProps): ReactNode {
  const { children, active, tabId, className = '', ...other } = props;

  const style = active
    ? {}
    : {
        display: 'none',
      };
  return (
    <div
      className={classNames('tabPanel', classes.tabPanel, className)}
      role="tabpanel"
      aria-hidden={!active}
      id={`tab-panel-${tabId}`}
      data-testid={`tab-panel-${tabId}`}
      aria-labelledby={`tab-${tabId}`}
      {...other}
      style={style}
    >
      {children}
    </div>
  );
}

export function a11yProps(id: string): { id: string; 'aria-controls': string } {
  return {
    id: `tab-${id}`,
    'aria-controls': `tab-panel-${id}`,
  };
}
